import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  activityDatePicker: 'date-picker',
  typeSelect: 'type-select',
  titleInput: 'title-input',
  certInput: 'cert-input',
  providerInput: 'provider-input',
  costInput: 'cost-input',
  creditsInput: 'credits-input',
  location: 'location-input',
  details: 'details-textbox',
  submitBtn: 'submit-btn',
  closeBtn: 'close-btn',
};

export default prefixObjectValues(modal, 'account-cme-training-form');
